export const companyList = 'admin/app/company/list';
export const companyDelete = 'admin/app/company/delete';
export const companyAdd = 'admin/app/company/add';
export const companyUpdate = 'admin/app/company/update';
export const companyBilling = 'admin/app/company/billing';
export const companyInvestmentStats = 'admin/app/company/investment_stats';
export const companyAvailableDocuments = 'admin/app/company/available_documents';
export const profileGet = 'admin/app/profile/get';
export const profileTaskData = 'admin/app/profile/task_data';
export const companyEdit = 'admin/app/company/edit';
